<template lang="html">

  <section class="tarif">
    <div id="content">

        <div class="c" id="tarif">
            <div class="titlebanner">
                <h3>Tarif</h3>
            </div>
            <div class="tarifContente">
                <section class="pricing py-5 ">
                    <!-- Tarif general -->
                    <div class="card mb-5 mb-lg-0">
                        <div class="card-body">
                            <h5 class="card-title text-uppercase text-center">General</h5>

                            <h6 class="card-price text-center">5.00<span class="period">%</span></h6>
                            <p class="card-subtitle  text-center">Ne payer que<br>sur les tickets<br>vendus</p>

                        </div>
                    </div>
                </section>
            </div>
        </div>

        <pied-creer-billetterie/>
    </div>
  </section>

</template>

<script lang="js">
  import PiedCreerBilletterie from '@/components/PiedCreerBilletterie'

  export default  {
    name: 'tarif',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    },
    components: {
      PiedCreerBilletterie
    }
}
</script>

<style scoped>
.tarifContente{
    margin: auto;
    width: 20em;
}

.card-title{
    padding-top: 1.2em;
    
}

.card-price{
    background-color: var(--sk-blue);
    padding-top: .30em;
    padding-bottom: .30em;
}
.card-subtitle{
    background-color: #597EAA;
    padding-top: 1.5em;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
    border-radius: 1rem;
    padding-bottom: 1.5em;
    
}
.section{
    padding-bottom: 5em;
}

.pricing .card {
border: none;
border-radius: 1rem;
transition: all 0.2s;
background-color: var(--sk-darkblue);
color: white;
}
   
.pricing .card-title {
  margin: 0.5rem 0;
  font-size: 0.9rem;
  letter-spacing: .1rem;
  font-weight: bold;
}

.pricing .card-price {
  font-size: 3rem;
  margin: 0;
}

.pricing .card-price .period {
  font-size: 2rem;
}  
  
/* Hover Effects on Card */

@media (min-width: 992px) {
  .pricing .card:hover {
    margin-top: -.25rem;
    margin-bottom: .25rem;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.3);
  }
  
}
</style>
